;
define("header_sidebar.tpl", function(){});

